// App.js

import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Landing from './components/views/Landing';
import Home from './components/views/Home';
import ShowResult from './components/views/ShowResult';
import SearchArtist from './components/views/Search.artist';
import Coffee from './components/views/Coffee';
import AdminDashboard from './components/views/AdminDashboard';
import DailyDiscovery from './components/views/DailyDiscovery';
import PrivacyRoute from './components/views/PrivacyRoute';
import Favorites from './components/views/Favorites';
import UserDashboard from './components/views/UserDashboard';
import { AppProvider } from './context/AppContext';
import { LanguageProvider } from './context/LanguageContext';
import { PrivacyProvider } from './context/PrivacyContext';
import PrivacyModal from './components/ui/PrivacyModal';
import CookieConsentBanner from './components/ui/CookieConsentBanner';
import DesktopRedirect from './components/common/DesktopRedirect';
import './App.css';

const ShowResultWithRouteKey = () => {
    const location = useLocation();
    const routeKey = `${location.pathname}-${location.state?.type || ''}-${location.state?.viewKey || ''}`;
    return <ShowResult key={routeKey} />;
};

const App = () => {
    return (
        <div className="App">
            <LanguageProvider>
                <PrivacyProvider>
                    <AppProvider>
                        <BrowserRouter>
                            <DesktopRedirect />
                            <div className="mobile-container">
                                <Routes>
                                    {/* Landing page senza layout */}
                                    <Route path="/" element={<Landing />} />
                                
                                    {/* App pages con layout */}
                                    <Route path="/home" element={
                                        <Layout>
                                            <Home />
                                        </Layout>
                                    } />
                            <Route path="/search" element={
                                <Layout>
                                    <SearchArtist />
                                </Layout>
                            } />
                            <Route path="/search/similar" element={
                                <Layout>
                                    <SearchArtist />
                                </Layout>
                            } />
                            <Route path="/similar" element={
                                <Layout>
                                    <ShowResultWithRouteKey />
                                </Layout>
                            } />
                            <Route path="/random" element={
                                    <Layout>
                                        <ShowResultWithRouteKey />
                                    </Layout>
                                } />
                                <Route path="/daily-discovery" element={
                                    <Layout>
                                        <DailyDiscovery />
                                    </Layout>
                                } />
                                <Route path="/daily-discovery-artists" element={
                                    <Layout>
                                        <ShowResultWithRouteKey />
                                    </Layout>
                                } />
                                <Route path="/top-artists" element={
                                    <Layout>
                                        <ShowResultWithRouteKey />
                                    </Layout>
                                } />
                                <Route path="/coffee" element={
                                    <Layout>
                                        <Coffee />
                                    </Layout>
                                } />
                                <Route path="/favorites" element={
                                    <Layout>
                                        <Favorites />
                                    </Layout>
                                } />
                                <Route path="/dashboard" element={
                                    <Layout>
                                        <UserDashboard />
                                    </Layout>
                                } />
                                
                                {/* Admin Dashboard - senza layout */}
                                <Route path="/admin" element={<AdminDashboard />} />
                                <Route path="/privacy" element={<PrivacyRoute />} />
                                
                                {/* Fallback */}
                                <Route path="*" element={<Landing />} />
                            </Routes>
                            </div>
                            <PrivacyModal />
                            <CookieConsentBanner />
                        </BrowserRouter>
                    </AppProvider>
                </PrivacyProvider>
            </LanguageProvider>
        </div>
    );
};

export default App;